





































import { Component, Vue, Prop } from 'vue-property-decorator'
import IRoute from '@/store/interface/IRoute'

@Component({
	name: 'SummaryTile'
})
export default class SummaryTile extends Vue {
	@Prop()
	private flightData!: IRoute
	@Prop({ default: false })
	private shiftOrder!: boolean
	@Prop({ default: 0 })
	private index!: number
}
